<template>
  <div class="aaaaa">
    <div class="bbbbb">
      <!-- 头部部分 -->
      <div ref="search_d">
        <el-form ref="form" :model="queryInfo.condition" label-width="100px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="用户昵称:">
                <el-input clearable v-model="queryInfo.condition.memberName" placeholder="请输入用户昵称"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="用户手机号:">
                <el-input clearable v-model="queryInfo.condition.phone" placeholder="请输入手机号"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="是否为vip">
                <el-select clearable style="width: 100%;" v-model="queryInfo.condition.vipTime" placeholder="是否为vip"
                           @change="vipTimeChange">
                  <el-option label="全部" value="0"></el-option>
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="2"></el-option>
                </el-select>
              </el-form-item>

            </el-col>

            <el-col :span="8">
              <el-form-item label="邀请人昵称">
                <el-input clearable v-model="queryInfo.condition.parentName" placeholder="邀请人昵称"></el-input>
              </el-form-item>

            </el-col>
            <el-col :span="8">
              <el-form-item label="邀请人手机号">
                <el-input clearable v-model="queryInfo.condition.parentPhone" placeholder="邀请人手机号"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="交易时间:">
                <el-date-picker  v-model="daterange" value-format="yyyy-MM-dd" type="daterange" style="width: 100%;"
                                @change="handleDateChange" range-separator="-" unlink-panels clearable
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                </el-date-picker>

              </el-form-item>
            </el-col>

            <el-col :span="24" style="display: flex;justify-content: flex-end;">
              <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
              <el-button @click="reset" class="pull-right" icon="el-icon-refresh-left">重置</el-button>
            </el-col>

          </el-row>

        </el-form>

      </div>

      <!-- 表格部分 -->
      <div>
        <div class="mt10 table_btn">
          <el-button type="primary" @click="toExport" class="mt10">导出</el-button>
        </div>
        <el-table v-loading="loading" border ref="table" :data="tableData" tooltip-effect="dark" style="width: 100%" :height="height">
          <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>

          <el-table-column label="头像" align="center" width="100px" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-image style="width: 50px;height: 50px;border-radius: 50%;" :src="scope.row.memberLogo"></el-image>
            </template>
          </el-table-column>
          <!-- <el-table-column label="id" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.id }}</template>
            </el-table-column> -->
          <!--        <el-table-column label="用户编码" align="center" show-overflow-tooltip width="250">-->
          <!--          <template slot-scope="scope">{{ scope.row.memberCode }}</template>-->
          <!--        </el-table-column>-->
          <el-table-column label="用户名称" align="center" show-overflow-tooltip width="120">
            <template slot-scope="scope">{{ scope.row.memberName }}</template>
          </el-table-column>
          <!-- <el-table-column label="账号" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.loginName }}</template>
            </el-table-column> -->
          <!-- <el-table-column label="密码MD5加密" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.pwd }}</template>
            </el-table-column> -->
          <!-- <el-table-column label="微信小程序openId" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.openId }}</template>
            </el-table-column> -->
          <!-- <el-table-column label="公众号openId" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.gzhOpenId }}</template>
            </el-table-column> -->
          <el-table-column label="用户类型" width="200" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{
                scope.row.userType === '1' ? '普通用户' :
                  scope.row.userType === '2' ? '企业管理员' : '企业员工'
              }}
            </template>
          </el-table-column>
          <el-table-column label="手机号" align="center" width="100px" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.phone }}</template>
          </el-table-column>
          <el-table-column label="是否vip" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.isVip == 1 ? '是' : '否' }}</template>
          </el-table-column>
          <!-- <el-table-column label="性别" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.sex==='1'?'男':scope.row.sex==='2'?'女':'未知' }}</template>
            </el-table-column>
            <el-table-column label="出生年月" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.birthday }}</template>
            </el-table-column> -->
          <!-- <el-table-column label="地址" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.address }}</template>
            </el-table-column> -->
          <!-- <el-table-column label="省级编码" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.provinceCode }}</template>
            </el-table-column>
            <el-table-column label="省级名称" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.provinceName }}</template>
            </el-table-column>
            <el-table-column label="市级编码" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.cityCode }}</template>
            </el-table-column>
            <el-table-column label="市级名称" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.cityName }}</template>
            </el-table-column>
            <el-table-column label="区级编码" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.areaCode }}</template>
            </el-table-column>
            <el-table-column label="区级名称" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.areaName }}</template>
            </el-table-column>
            <el-table-column label="真实姓名" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.trueName }}</template>
            </el-table-column>
            <el-table-column label="年龄" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.age }}</template>
            </el-table-column>
            <el-table-column label="经度" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.longitude }}</template>
            </el-table-column>
            <el-table-column label="纬度" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.latitude }}</template>
            </el-table-column>
            <el-table-column label="是否实名认证" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.isAuth }}</template>
            </el-table-column>
            <el-table-column label="设备编码" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.deviceCode }}</template>
            </el-table-column>
            <el-table-column label="人脸图片" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.faceUrl }}</template>
            </el-table-column>
            <el-table-column label="账号状态" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.accountStatus }}</template>
            </el-table-column> -->

          <!-- <el-table-column label="修改时间" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.updateDate }}</template>
            </el-table-column>
            <el-table-column label="背景图" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.bgUrl }}</template>
            </el-table-column>
            <el-table-column label="简介" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.memberInfo }}</template>
            </el-table-column>
            <el-table-column label="登录ip" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.loginIp }}</template>
            </el-table-column>
            <el-table-column label="注册渠道" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.registerSource }}</template>
            </el-table-column>
            <el-table-column label="登录地区" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.loginAddress }}</template>
            </el-table-column>
            <el-table-column label="系统" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.systemType }}</template>
            </el-table-column>
            <el-table-column label="机型" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.modelType }}</template>
            </el-table-column>
            <el-table-column label="最后登录时间" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.lastLoginTime }}</template>
            </el-table-column> -->
          <!-- <el-table-column label="上级邀请人名称" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.parentName }}</template>
            </el-table-column> -->
          <!-- <el-table-column label="上级邀请人编码" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.parentCode }}</template>
            </el-table-column> -->

          <!-- <el-table-column label="会员等级编码" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.vipLevelCode }}</template>
            </el-table-column> -->
          <el-table-column label="vip级别" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.vipLevelName }}</template>
          </el-table-column>
          <el-table-column label="vip到期时间" align="center" show-overflow-tooltip width="180">
            <template slot-scope="scope">{{ scope.row.openLimitTime }}</template>
          </el-table-column>

          <el-table-column label="邀请人头像" width="120" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.parentPicture }}</template>
          </el-table-column>
          <el-table-column label="邀请人昵称" width="120" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.parentName }}</template>
          </el-table-column>
          <el-table-column label="邀请人手机号" width="120" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.parentPhone }}</template>
          </el-table-column>
          <el-table-column label="购买次数" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.totalCount }}</template>
          </el-table-column>
          <el-table-column label="退货次数" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.returnCount }}</template>
          </el-table-column>
          <el-table-column label="退货率" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.returnRate }}</template>
          </el-table-column>
          <el-table-column label="交易总额" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.totalTransactionMoney }}</template>
          </el-table-column>
          <!-- <el-table-column label="vip开通时间" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.openVipTime }}</template>
            </el-table-column>

            <el-table-column label="是否认证企业" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.isAuthCompany }}</template>
            </el-table-column> -->
          <!-- <el-table-column label="企业认证时间" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.authCompanyTime }}</template>
            </el-table-column> -->
          <!-- <el-table-column label="客户类型" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.customType }}</template>
            </el-table-column> -->
          <el-table-column label="可用积分" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.score }}</template>
          </el-table-column>
          <el-table-column label="可用余额" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.balance }}</template>
          </el-table-column>

          <el-table-column label="上次交易时间" align="center" width="200px" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.lastOrderTime }}</template>
          </el-table-column>
<!--          <el-table-column label="操作" width="135" align="center" fixed="right">-->
<!--            <template slot-scope="scope">-->
<!--              <el-button type="text" @click="edit(scope.row)" size="small">编辑</el-button>-->
<!--              &lt;!&ndash; <el-popconfirm title="确定删除吗？" @onConfirm="handleDelte(scope.row.id)">-->
<!--                <el-button slot="reference" type="text">删除</el-button>-->
<!--              </el-popconfirm> &ndash;&gt;-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
        <!-- 分页 -->
        <div class="block">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="queryInfo.currPage" :page-sizes="[100, 200, 300, 400]"
                         :page-size="queryInfo.pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>

    </div>
    <el-dialog :title="(labelType == 'add' ? '新增' : '编辑')" :visible.sync="showDialog" width="800px">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-row :gutter="10">

          <el-col :span="12">
            <el-form-item label="id：" prop="siteName">
              <el-input v-model="form.id" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <!--          <el-col :span="12">-->
          <!--            <el-form-item label="用户编码：" prop="siteName">-->
          <!--              <el-input v-model="form.memberCode" placeholder="请输入名称"></el-input>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <el-col :span="12">
            <el-form-item label="用户名称：" prop="siteName">
              <el-input v-model="form.memberName" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="账号密码：" prop="siteName">
              <el-input v-model="form.loginName" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码MD5加密：" prop="siteName">
              <el-input v-model="form.pwd" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="微信小程序openId：" prop="siteName">
              <el-input v-model="form.openId" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公众号openId：" prop="siteName">
              <el-input v-model="form.gzhOpenId" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号：" prop="siteName">
              <el-input v-model="form.phone" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="头像：" prop="siteName">
              <el-input v-model="form.memberLogo" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别：" prop="siteName">
              <el-input v-model="form.sex" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出生年月：" prop="siteName">
              <el-input v-model="form.birthday" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址：" prop="siteName">
              <el-input v-model="form.address" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="省级编码：" prop="siteName">
              <el-input v-model="form.provinceCode" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="省级名称：" prop="siteName">
              <el-input v-model="form.provinceName" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="市级编码：" prop="siteName">
              <el-input v-model="form.cityCode" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="市级名称：" prop="siteName">
              <el-input v-model="form.cityName" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="区级编码：" prop="siteName">
              <el-input v-model="form.areaCode" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="区级名称：" prop="siteName">
              <el-input v-model="form.areaName" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="真实姓名：" prop="siteName">
              <el-input v-model="form.trueName" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年龄：" prop="siteName">
              <el-input v-model="form.age" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经度：" prop="siteName">
              <el-input v-model="form.longitude" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纬度：" prop="siteName">
              <el-input v-model="form.latitude" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否实名认证：" prop="siteName">
              <el-input v-model="form.isAuth" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备编码：" prop="siteName">
              <el-input v-model="form.deviceCode" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="人脸图片：" prop="siteName">
              <el-input v-model="form.faceUrl" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="账号状态：" prop="siteName">
              <el-input v-model="form.accountStatus" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间：" prop="siteName">
              <el-input v-model="form.createDate" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改时间：" prop="siteName">
              <el-input v-model="form.updateDate" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="背景图：" prop="siteName">
              <el-input v-model="form.bgUrl" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="简介：" prop="siteName">
              <el-input v-model="form.memberInfo" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="登录ip：" prop="siteName">
              <el-input v-model="form.loginIp" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册渠道：" prop="siteName">
              <el-input v-model="form.registerSource" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="登录地区：" prop="siteName">
              <el-input v-model="form.loginAddress" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="系统：" prop="siteName">
              <el-input v-model="form.systemType" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机型：" prop="siteName">
              <el-input v-model="form.modelType" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最后登录时间：" prop="siteName">
              <el-input v-model="form.lastLoginTime" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上级邀请人名称：" prop="siteName">
              <el-input v-model="form.parentName" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上级邀请人编码：" prop="siteName">
              <el-input v-model="form.parentCode" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户类型：" prop="siteName">
              <el-input v-model="form.userType" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="会员等级编码：" prop="siteName">
              <el-input v-model="form.vipLevelCode" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="会员等级名称：" prop="siteName">
              <el-input v-model="form.vipLevelName" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="vip开通时间：" prop="siteName">
              <el-input v-model="form.openVipTime" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="vip到期时间：" prop="siteName">
              <el-input v-model="form.openLimitTime" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否认证企业：" prop="siteName">
              <el-input v-model="form.isAuthCompany" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业认证时间：" prop="siteName">
              <el-input v-model="form.authCompanyTime" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户类型：" prop="siteName">
              <el-input v-model="form.customType" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="余额：" prop="siteName">
              <el-input v-model="form.balance" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="积分：" prop="siteName">
              <el-input v-model="form.score" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSave">确定</el-button>
      </span>
    </el-dialog>

    <el-drawer size="70%" :visible.sync="drawer" :with-header="false" :before-close="handleClose">
      <!--      <detail :memberCode="memberCode" @close="handleClose"/>-->
            <detail ref="memberDetail" @close="handleClose"/>
    </el-drawer>
  </div>
</template>

<script>
import detail from './components/detail.vue'

export default {
  components: { detail },
  data () {
    return {
      drawer: false,
      labelType: 'add',
      rules: {},
      total: 0,
      queryInfo: {
        pageSize: 100,
        pageCount: 1,
        currPage: 1,
        condition: {
          vipStartTime: null,
          vipEndTime: null,
          vipTime: ''
        }
      },
      form: {},
      showDialog: false,
      tableData: [],
      height: window.innerHeight - 256, // 表格高度
      headerHeight: 0,
      daterange: [],
      memberCode: '',
      loading: false
    }
  },

  created () {
    this.getList()
  },

  mounted () {
    this.$nextTick(() => {
      // 获取定义ref属性 和 元素高度
      this.headerHeight = this.$refs.search_d.offsetHeight
      window.addEventListener('resize', this.getHeight())
    })
  },

  methods: {

    search () {
      this.queryInfo.currPage = 1
      this.getList()
    },

    // 导出
    async toExport () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出中，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const that = this
      let url = '/exportExcel/exportMember'
      const res = await this.$http.post(url, that.queryInfo,
        { responseType: 'blob' })
      if (res.status == 200) {
        try {
          const fileUrl = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = fileUrl
          link.target = '_blank'
          link.setAttribute('download', `会员数据表格.xls`) // 设置导出的文件名称
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          loading.close()
          that.$message({ type: 'success', message: '导出成功' })
        } catch (error) {
          this.$message.error(error)
        }
      }
    },

    // 监听表格高度
    getHeight () {
      this.height = window.innerHeight - this.headerHeight - 256
    },
    handleDateChange (val) {
      this.queryInfo.condition.startTime = val[0]
      this.queryInfo.condition.endTime = val[1]
    },
    vipTimeChange (val) {
      switch (val) {
        case '0':
          this.queryInfo.condition.vipStartTime = null
          this.queryInfo.condition.vipEndTime = null
          break
        case '1':
          this.queryInfo.condition.vipStartTime = null
          this.queryInfo.condition.vipEndTime = 1
          break
        case '2':
          this.queryInfo.condition.vipStartTime = 1
          this.queryInfo.condition.vipEndTime = null
          break

        default:
          break
      }
    },
    // 获取数据
    getList () {
      var that = this
      that.loading = true
      console.log(that.queryInfo)
      that.$http.post('/member/list', that.queryInfo).then(function (response) {
        console.log(response.data.data)
        if (response.data.code == 200) {
          that.loading = false
          that.total = response.data.data.count
          that.queryInfo.currPage = response.data.data.currPage
          that.tableData = response.data.data.data
        } else {
          that.loading = false
          that.$message.error(response.data.message)
        }
      })
    },

    // 保存
    handleSave () {
      var that = this
      that.$http.post('/member/save', that.form).then(function (response) {
        if (response.data.code == 200) {
          that.$notify.success({
            title: '提示',
            message: '保存成功',
            showClose: true
          })
          that.showDialog = false
          that.getList()
        } else {
          that.$notify.info({
            title: '提示',
            message: response.data.message,
            showClose: true
          })
        }
      }).catch(function (error) {

      })
    },

    // 修改
    edit (row) {
      this.drawer = true
      // this.labelType = 'edit'
      // this.form = JSON.parse(JSON.stringify(row))
      // this.memberCode = row.memberCode
      // console.log('详情==', this.memberCode)
      this.$nextTick(() => {
        console.log(this.$refs.memberDetail, 696)
        this.$refs.memberDetail.init(row.memberCode)
      })
    },

    // 删除当前行
    //    handleDelte (id) {
    //      del({ id: id }).then(res => {
    //        if (res.code == 200) {
    //         this.$message.success('删除成功')
    //         this.getList()
    //       }
    //      })
    //    },

    reset () {
      this.queryInfo = {
        pageSize: 100,
        pageCount: 1,
        currPage: 1,
        condition: {}

      }
      this.daterange = []
      this.getList()
    },

    // 删除用户
    async handleDelte (id) {
      const confirmResult = await this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      if (confirmResult === 'confirm') {
        var that = this
        that.$http.post('/member/delete', { 'id': id }).then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: '提示',
              message: '删除成功',
              showClose: true
            })
            that.getList()
          } else {
            that.$notify.info({
              title: '提示',
              message: response.data.message,
              showClose: true
            })
          }
        })
      }
    },

    // 新增按钮
    newBtn () {
      this.labelType = 'add'
      this.showDialog = true
      this.form = {}
    },

    // 修改页数大小
    handleSizeChange (val) {
      this.queryInfo.pageSize = val
      this.getList()
    },

    // 获取当前页面
    handleCurrentChange (val) {
      this.queryInfo.currPage = val
      this.getList()
    },
    handleClose () {
      this.drawer = false
    }

  }
}
</script>

<style scoped></style>
